import water_logo from "../../images/water-drop.png";

interface Props {
  className: any;
  frame?: string;
  attachment?: string;
  text: string;
  text1: string;
  valeur?: string;
  desc?: string;
  norme?: string;
}
export const Frame = ({
  className,
  frame = "https://c.animaapp.com/QV39jVC4/img/frame-427319636.svg",
  attachment = water_logo,
  text = "Potassium",
  text1 = "K+",
  valeur = "1",
  norme = "norme",
  desc = "lorem ipsum dolor sit amet, consectetur adip",
}: Props): JSX.Element => {
  return (
    <div
      className={`inline-flex flex-col items-start gap-[2px] p-[10px] relative ${className}`}
    >
      <img className="relative flex-[0_0_auto]" alt="Frame" src={frame} />
      <div className="flex w-[239px] items-start gap-[12px] relative flex-[0_0_auto]">
        <img
          className="relative  h-[20px]  md:w-[41px] md:h-[63px]  "
          alt="Attachment"
          src={attachment}
        />
        <div className="flex flex-col h-[117px] w-[144px] md:w-[144px] md:h-[117px] items-start relative">
          <div className="border-b border-primary flex w-[145px] h-[27px] items-center gap-[38px] relative mr-[-1.00px]">
            <div className="  relative flex-1 mt-[-3.50px] mb-[-1.50px] [font-family:'Roboto',Helvetica] font-medium text-black text-[16px] tracking-[0] leading-[32px]">
              {text}
            </div>
            <div className="relative w-fit mt-[-12.50px] mb-[-10.50px] [font-family:'Roboto',Helvetica] font-light text-[#44c6f4] text-[25px] tracking-[0] leading-[50px] whitespace-nowrap">
              {text1}
            </div>
          </div>
          <div className="flex flex-col w-[144px] items-start gap-[9px] relative flex-[0_0_auto] mb-[-18.00px]">
            <div className="relative self-stretch w-full h-[2px] bg-aquavesc" />
            <div className="relative w-[163px] h-[97px] mr-[-19.00px] [font-family:'Roboto',Helvetica] font-medium text-[#565656] text-[13px] tracking-[0] leading-[26px]">
              <span className="text-[15px] font-bold text-black"> {valeur}</span>
             <p className="text-[15px]">Norme : {norme}</p> 
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
